// Shared external links. Cloudbet referral/partner link — used everywhere we point
// users to sign up for a Cloudbet account.
export const CLOUDBET_REFERRAL_URL = "https://cldbt.cloud/r/cryptosid";
